export default {
  init() {

  },
  finalize() {

    // Close all menus and make their children untabbable
    function closeAllMenus() {
      $('.global-navbar-wrap .main-wrap .main-nav-wrap .nav-link-wrap.open').each(function() {
        $(this).removeClass('open');

        $(this).find('.nav-link-sub-menu').find('a').each(function() {
          $(this).attr('tabindex', '-1');
        });
      });

      if ($('.global-navbar-wrap').hasClass('no-banner-temp')) {
        $('.global-navbar-wrap').removeClass('no-banner-temp').addClass('no-banner');
      }
    }

    // Close sub menu (click off)
    $('body').on('click', function(e) {
      const $target = $(e.target);

      if ($target.parents('.global-navbar-wrap').length == 0) {
        closeAllMenus();
      }
    });

    // Open sub menu
    $('.global-navbar-wrap .main-wrap .main-nav-wrap .nav-link-wrap').each(function() {
      const $link = $(this).find('.nav-link.has-children');
      if ($link.length > 0) {
        $link.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var alreadyOpen = $(this).parent().hasClass('open');

          closeAllMenus();

          if (!alreadyOpen) {
            // Open this sub menu
            $(this).parent().addClass('open');

            // If the page has no banner we need to remove this class and add a temp class to revert from
            if ($('.global-navbar-wrap').hasClass('no-banner')) {
              $('.global-navbar-wrap').removeClass('no-banner').addClass('no-banner-temp');
            }

            // Make all children tabbable
            $(this).siblings('.nav-link-sub-menu').find('a').each(function() {
              $(this).attr('tabindex', '0');
            });
          }
        });
      }
    });
    

    // On scroll down
    var lastScrollY = 0;
    var desktop = true;
    var navWrap;
    var anchorTop;

    $(window).on('scroll', function() {
      const scrollY = $(window).scrollTop();
      var threshold;

      if (jQuery(window).width() < 1200) {
        // Mobile.
        desktop = false;
        navWrap = 'global-mobile-navbar-wrap';
        threshold = $(`.${navWrap}`).height() + 250;
      } else {
        // Desktop.
        desktop = true;
        navWrap = 'global-navbar-wrap';
        threshold = $(`.${navWrap}`).height() + 350;
      }

      if (lastScrollY < scrollY) {
        // Scrolling down

        if (desktop) {
          // Close any submenus
          $(`.${navWrap} .nav-link-wrap.open`).removeClass('open');
        }
        
        // If scroll Y is greater than the threshold, make the navbar fixed.
        // if (scrollY > threshold) {
        //   $(`.${navWrap}`).addClass('fixed');

        //   if ($(`.${navWrap}`).hasClass('no-banner')) {
        //     // Different colours for those with no banner so we need to shift this a bit
        //     $(`.${navWrap}`).addClass('no-banner-temp').removeClass('no-banner');
        //   }
          
        //   // Add the hiding class - scrolling up should hide the nav
        //   $(`.${navWrap}`).addClass('hiding');
        // }

        if (scrollY > 0) {
          // console.log('scrolling down');
          $(`.${navWrap}`).addClass('fixed');

          if ($(`.${navWrap}`).hasClass('no-banner')) {
            // Different colours for those with no banner so we need to shift this a bit
            $(`.${navWrap}`).addClass('no-banner-temp').removeClass('no-banner');
          }
          
          // // Add the hiding class - scrolling up should hide the nav
          // $(`.${navWrap}`).addClass('hiding');
        }

        // Push anchor links back to where it should be
        if ($('.shared-anchor-links').length > 0) {
          anchorTop = 0;

          if ($('body').hasClass('logged-in')) {
            if ($(window).width() >= 600) {
              anchorTop = 45;
            }

            if ($(window).width() >= 782) {
              anchorTop = 31;
            }
          }

          $('.shared-anchor-links').css({ top: String(anchorTop) + 'px' });
        }
      } else {
        // Scrolling up
        // $(`.${navWrap}`).removeClass('hiding');

        // If scroll Y is less than the threshold, remove the fix from the navbar
        // if (scrollY <= threshold) {
        //   $(`.${navWrap}`).removeClass('fixed');
        //   $(`.${navWrap}`).removeClass('show');
          
        //   if ($(`.${navWrap}`).hasClass('no-banner-temp')) {
        //     $(`.${navWrap}`).addClass('no-banner').removeClass('no-banner-temp');
        //   }
        // } else {
        //   // Show the navbar
        //   $(`.${navWrap}`).addClass('show');

        //   // If there is an anchor links bar we need to push it down
        //   if ($('.shared-anchor-links').length > 0) {
        //     const navHeight = $(`.${navWrap}`).height();
        //     anchorTop = navHeight;

        //     if ($(window).width() >= 584) {
        //       if ($('body').hasClass('logged-in')) {
        //         anchorTop += 45;
        //       }
        //     }

        //     if ($(window).width() >= 782) {
        //       anchorTop = navHeight;
              
        //       if ($('body').hasClass('logged-in')) {
        //         anchorTop += 31;
        //       }
        //     }

        //     $('.shared-anchor-links').css({ top: String(anchorTop) + 'px' });
        //   }
        // }

        // If we hit the top of the page, hide the navbar
        if (scrollY <= 0) {
          $(`.${navWrap}`).removeClass('fixed');
          // $(`.${navWrap}`).removeClass('show');
          
          if ($(`.${navWrap}`).hasClass('no-banner-temp')) {
            $(`.${navWrap}`).addClass('no-banner').removeClass('no-banner-temp');
          }
        }

      }

      lastScrollY = scrollY;
    });

    // Open search.
    $('.nav-link-wrap.link-search > a').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      $('.global-search').addClass('show');
      $('body').addClass('overflow-hidden');

      setTimeout(() => {
        $('.global-search .search-input').focus();
      }, 150);
    });

    // On hover over a top level link, turn all other links transparent
    $('.global-navbar-wrap .main-nav-wrap > .nav-link-wrap .nav-link').on('mouseenter focus', function() {
      $(this).addClass('hover');
      $('.global-navbar-wrap .main-nav-wrap').addClass('hover');
    });

    $('.global-navbar-wrap .main-nav-wrap > .nav-link-wrap .nav-link').on('mouseout blur', function() {
      $(this).removeClass('hover');
      $('.global-navbar-wrap .main-nav-wrap').removeClass('hover');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigation.js